import {Injectable} from '@angular/core';
import {Actions, Effect, ofType} from '@ngrx/effects';
import {QuestionnaireService} from '../../services/questionnaire.service';
import {
  GetPendingsFailure,
  GetPendingsSuccess,
  PatientActionTypes
} from '../actions/patient.actions';
import {switchMap, tap} from 'rxjs/operators';
import {Observable} from 'rxjs';

@Injectable()
export class PatientEffects {

  constructor(
    private actions$: Actions,
    private questionnaireService: QuestionnaireService) {}

  @Effect()
  GetPendings: Observable<any> = this.actions$.pipe(
    ofType(PatientActionTypes.GET_PENDINGS),
    tap( () => console.log(PatientActionTypes.GET_PENDINGS + ' Effect')),
    switchMap(() => {
      return this.questionnaireService.getAllPendings()
        .map((pendingArray) => {
          return new GetPendingsSuccess({
            pendings: pendingArray  // TODO: WATCH AFTER CLASS WRITTEN
          });
        })
        .catch((error) => {
          console.log(error);
          return Observable.of(new GetPendingsFailure({ error }));
        });
    }));

  @Effect({ dispatch: false })
  GetPendingsSuccess: Observable<any> = this.actions$.pipe(
    ofType(PatientActionTypes.GET_PENDINGS_SUCCESS),
    tap((data) => {
      localStorage.setItem('pendings', JSON.stringify(data.payload.pendings));
    })
  );

  @Effect({ dispatch: false })
  GetPendingsFailure: Observable<any> = this.actions$.pipe(
    ofType(PatientActionTypes.GET_PENDINGS_FAILURE)
  );

}
